import { useSelector } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as icon from '@fortawesome/free-solid-svg-icons';
import SectionEditLink from './SectionEditLink';

const SECTIONS = [
  { type: 'availability', label: 'Reservations' },
  { type: 'services', label: 'Services' },
  { type: 'safety', label: 'Health and Safety' },
  { type: 'certifications', label: 'Certifications' },
];

export default function AccommodationsInfoPanel() {
  const listing = useSelector((s) => s.listings.selected);
  const accommodations = listing.accommodation || [];

  const grouped = {};
  for (const section of SECTIONS) {
    grouped[section.type] = accommodations.filter(a => a.type === section.type);
  }

  return (
    <div className="bg-white shadow overflow-hidden px-4 py-5 sm:rounded-lg sm:p-6">
      <div className="px-4 py-5 sm:px-6 flex items-start justify-between gap-4">
        <h3 className="text-lg leading-6 font-medium text-gray-900">
          Accommodations
        </h3>
        <SectionEditLink section="amenities" />
      </div>

      <div className="border-t border-gray-200 px-4 py-5 sm:px-6">
        <div className="space-y-6">
          {SECTIONS.map(({ type, label }) => (
            <div key={type}>
              <h4 className="text-sm font-medium text-gray-900 mb-3">{label}</h4>
              {grouped[type].length > 0 ? (
                <div className="flex flex-wrap gap-2">
                  {grouped[type].map(a => (
                    <span key={a.id} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium bg-gray-100 text-gray-800">
                      {icon[a.iconId] && <FontAwesomeIcon icon={icon[a.iconId]} className="w-3.5 text-gray-500" />}
                      {a.name}
                    </span>
                  ))}
                </div>
              ) : (
                <p className="text-sm text-gray-400">None selected</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
